module.exports = __webpack_public_path__ + "img/Thailand-4.74d8ab98.jpg";